// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import axios from 'axios'
import '@/assets/font/iconfont.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(ViewUI);


Vue.prototype.$http = axios
Vue.prototype.$http.defaults.baseURL = 'http://47.95.213.107/changyinweb' // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',

})



// WEBPACK FOOTER //
// ./src/main.js